"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'access.status.active': 'Active',
    'access.status.inactive': 'Inactive',
};
